var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button-element',{attrs:{"loading":_vm.isLoading,"size":"xsmall","type":"danger"},on:{"click":_vm.deleteComment}},[_vm._v(" Oui, Supprimer ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }